import {Component, OnInit} from '@angular/core';
import {LoanApplicationFlowSteps} from '../../application-flow/steps/loan-application-flow.steps';
import {Step} from '../../application-flow/steps/step';
import {Location} from '@angular/common';
import {NavigationStart, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {TimelineStep, TimelineStepStatus} from '../../common/timeline-progress-bar/timeline.step.model';

@Component({
  selector: 'app-borrower-registration-progress-bar',
  templateUrl: './borrower-registration-progress-bar.component.html',
  styleUrls: ['./borrower-registration-progress-bar.component.css']
})
export class BorrowerRegistrationProgressBarComponent implements OnInit {

  public readonly applicationFlowSteps: LoanApplicationFlowSteps;
  public timelineSteps: TimelineStep[];
  constructor(loanApplicationFlowSteps: LoanApplicationFlowSteps, private router: Router) {
    this.applicationFlowSteps = loanApplicationFlowSteps;
    this.timelineSteps = [];
    this.populateTimelineSteps();
    router.events.pipe(filter(event => event instanceof NavigationStart))
        .subscribe(() => this.updateStatusOfSteps());
  }

  async ngOnInit(): Promise<void> {
    await this.updateStatusOfSteps();
  }

  private async updateStatusOfSteps() {
    const isStepComplete = new Map<Step, boolean>();
    for (const step of this.applicationFlowSteps) {
      if (step.displayName() !== undefined) {
        const timelineStep = this.timelineSteps.find(s => s.description === step.displayName());
        const isComplete = await step.isComplete();
        if (!isComplete) {
          const isStepInProgress = Array.from(isStepComplete.values()).every(v => v);
          const stepStatus = isStepInProgress ? TimelineStepStatus.ACTIVE : TimelineStepStatus.PENDING;
          timelineStep.status = stepStatus;
        } else {
          timelineStep.isClickable = true;
          timelineStep.url = step.url();
          timelineStep.status = TimelineStepStatus.COMPLETE;
        }
        isStepComplete.set(step, isComplete);
      }
    }
  }

  navigate(step: TimelineStep) {
    this.router.navigate([step.url]);
  }
  private populateTimelineSteps() {
    for (const step of this.applicationFlowSteps) {
      if (step.description() !== undefined) {
        const timelineStep = new TimelineStep();
        timelineStep.description = step.displayName();
        this.timelineSteps.push(timelineStep);
      }
    }
  }
}
